import { render, staticRenderFns } from "./VTaskCommentEditor.vue?vue&type=template&id=14af19f4&scoped=true"
import script from "./VTaskCommentEditor.vue?vue&type=script&lang=ts"
export * from "./VTaskCommentEditor.vue?vue&type=script&lang=ts"
import style0 from "./VTaskCommentEditor.vue?vue&type=style&index=0&id=14af19f4&prod&lang=scss&scoped=true"
import style1 from "./VTaskCommentEditor.vue?vue&type=style&index=1&id=14af19f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14af19f4",
  null
  
)

export default component.exports